import { decryptBackup, encryptBackup } from "bitcoin-backup";
import { type SeedBackup, validateSeedBackup } from "./seed-contract";
import {
	assertValidLegacyBackup,
	type ValidatedLegacyBackup,
} from "./validate-backup";
export type IdentityBackup = ValidatedLegacyBackup | SeedBackup;
/** Dispatch marker only. Validate every untrusted boundary before using this narrowing. */
export function isSeedIdentityBackup(value: unknown): value is SeedBackup {
	return (
		value !== null &&
		typeof value === "object" &&
		"format" in value &&
		value.format === "sigma-seed"
	);
}
export function validateIdentityBackup(value: unknown): IdentityBackup {
	if (isSeedIdentityBackup(value)) {
		return validateSeedBackup(value);
	}
	assertValidLegacyBackup(value);
	return value;
}
export async function encryptIdentityBackup(
	value: IdentityBackup,
	password: string
): Promise<string> {
	return await encryptBackup(validateIdentityBackup(value), password);
}
export async function decryptIdentityBackup(
	encrypted: string,
	password: string
): Promise<IdentityBackup> {
	// No raw-decryption fallback for an older package reader.
	return validateIdentityBackup(await decryptBackup(encrypted, password));
}
